/* CWC · Einzeilige Überschriften am Handy sicher einpassen · 09.10.2026
   Betrifft nur Zeilen, die bewusst einzeilig sind (Claim der Startseite, „ZWEI DÜFTE. ZWEI CHARAKTERE.“,
   Titel über Logo-Zeilen). Passt eine Zeile auf einem sehr schmalen Gerät (z. B. iPhone SE, iPhone 6s)
   nicht in die Spalte, wird die Schrift in kleinen Schritten verkleinert, bis sie passt.
   Nichts wird abgeschnitten, nichts ragt seitlich hinaus. Desktop bleibt unberührt. */
(function () {
  var SELECTOR = '.cwc-home-editorial__claim, .cwc-home-editorial__characters, .shopify-section--logo-list .logo-list__heading';
  var MIN_PX = 12;

  function fit() {
    var mobile = window.matchMedia('(max-width: 768px)').matches;
    var els = document.querySelectorAll(SELECTOR);
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      el.style.removeProperty('font-size');
      if (!mobile) continue;
      var size = parseFloat(window.getComputedStyle(el).fontSize) || 0;
      var guard = 0;
      while (el.scrollWidth > el.clientWidth + 1 && size > MIN_PX && guard < 60) {
        size -= 0.5;
        el.style.setProperty('font-size', size + 'px', 'important');
        guard++;
      }
    }
  }

  function run() {
    fit();
    if (document.fonts && document.fonts.ready) { document.fonts.ready.then(fit); }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run, { once: true });
  } else {
    run();
  }
  window.addEventListener('load', fit, { once: true });

  var t;
  window.addEventListener('resize', function () {
    window.clearTimeout(t);
    t = window.setTimeout(fit, 150);
  });
  document.addEventListener('shopify:section:load', function () { window.setTimeout(fit, 100); });
})();

/* CWC · Schöne Zeilenumbrüche auf allen Seiten · 20.10.2026 (Anweisung Christoph)
   Nur Darstellung, kein Text wird geändert (SEO neutral, Überschriften-Hierarchie unverändert):
   1) Überschriften, Dachzeilen, Bildzeilen, Eckdaten mit „ · “: Jeder Teil bleibt zusammen, der Punkt steht nie
      am Zeilenanfang oder -ende (an einem Umbruch wird er ausgeblendet).
   2) In Überschriften bleiben kurze Wörter (&, und, mit, von, the, of …) beim nächsten Wort.
   3) Im ganzen Inhalt bleiben Zahl und Einheit zusammen (75 ml, 20 %, 80 °C, 2 × 20 ml, z. B.).
   4) Zeilen mit Punkten zwischen Angaben (FAQ-Kurzinfo, Themen-Navigation): kein Punkt am Zeilenanfang. */
(function () {
  var HEAD = 'h1,h2,h3,h4,figcaption,[class*="kicker"],[class*="eyebrow"],[class*="__lead"],[class*="__label"],[class*="__statement"],[class*="__claim"],.cwc-marke__fact-value,.cwc-marke__fact-label';
  var ROWS = '.cwc-marke__brief-facts,.cwc-marke__faq-nav';
  var NB = '\u00a0';
  var SHORT = /(^|[\s\u00a0])(&|und|oder|zu|im|in|am|an|auf|aus|bei|mit|von|vom|zum|zur|für|der|die|das|den|dem|des|ein|eine|a|the|and|of|to|for|with|by|at|on)\s+/gi;

  var css = document.createElement('style');
  css.textContent =
    '.cwc-seg{white-space:nowrap}.cwc-seg.cwc-seg--free{white-space:normal}' +
    '.cwc-sep.cwc-sep--off{display:none}' +
    'html body #main-content .cwc-marke p.cwc-marke__brief-facts span.cwc-ls::before,' +
    'html body #main-content .cwc-marke .cwc-marke__faq-nav a.cwc-ls::before{display:none!important;content:none!important}';
  document.head.appendChild(css);

  function units(root) {
    var w = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null), n, v, nv;
    while ((n = w.nextNode())) {
      v = n.nodeValue;
      if (!v || !/\d|z\. B\./.test(v)) continue;
      nv = v
        .replace(/(\d)\s+(×)\s+(\d)/g, '$1' + NB + '$2' + NB + '$3')
        .replace(/(\d)\s+(ml|ML|%|°C|g|kg|cm|mm|h|Min\.|Minuten|Stunden|Jahre|Euro|EUR|€)(?=[\s.,;:!?)]|$)/g, '$1' + NB + '$2')
        .replace(/z\. B\./g, 'z.' + NB + 'B.');
      if (nv !== v) n.nodeValue = nv;
    }
  }

  function onlyText(el) {
    for (var i = 0; i < el.childNodes.length; i++) {
      var c = el.childNodes[i];
      if (c.nodeType === 3) continue;
      if (c.nodeType === 1 && c.tagName === 'BR') continue;
      return false;
    }
    return true;
  }

  function build(el) {
    if (el.getAttribute('data-cwc-lines')) return;
    el.setAttribute('data-cwc-lines', '1');
    if (!onlyText(el)) return;
    var text = el.textContent;
    if (!text || !text.trim()) return;
    var glued = function (s) { return s.replace(SHORT, function (m, p, w) { return p + w + NB; }); };
    if (text.indexOf('\u00b7') === -1) {
      if (el.querySelector('br')) return;
      var g = glued(text);
      if (g !== text) el.textContent = g;
      return;
    }
    var parts = text.split(/\s*\u00b7\s*/), frag = document.createDocumentFragment(), first = true;
    for (var i = 0; i < parts.length; i++) {
      var p = parts[i].trim();
      if (!p) continue;
      if (!first) {
        var sep = document.createElement('span');
        sep.className = 'cwc-sep';
        sep.textContent = NB + '\u00b7';
        frag.appendChild(sep);
        frag.appendChild(document.createTextNode(' '));
      }
      var seg = document.createElement('span');
      seg.className = 'cwc-seg';
      seg.textContent = glued(p);
      frag.appendChild(seg);
      first = false;
    }
    el.textContent = '';
    el.appendChild(frag);
  }

  function top(e) { return e.getBoundingClientRect().top; }

  function measure() {
    var main = document.getElementById('main-content') || document.body;
    var segs = main.querySelectorAll('.cwc-seg'), i;
    for (i = 0; i < segs.length; i++) segs[i].classList.remove('cwc-seg--free');
    var seps = main.querySelectorAll('.cwc-sep');
    for (i = 0; i < seps.length; i++) seps[i].classList.remove('cwc-sep--off');
    for (i = 0; i < segs.length; i++) {
      var box = segs[i].parentNode;
      if (box && segs[i].getBoundingClientRect().width > box.clientWidth + 1) segs[i].classList.add('cwc-seg--free');
    }
    for (i = 0; i < seps.length; i++) {
      var s = seps[i], next = s.nextSibling;
      while (next && next.nodeType !== 1) next = next.nextSibling;
      if (next && top(next) > top(s) + 2) s.classList.add('cwc-sep--off');
    }
    var rows = main.querySelectorAll(ROWS);
    for (i = 0; i < rows.length; i++) {
      var kids = rows[i].children, j;
      for (j = 0; j < kids.length; j++) kids[j].classList.remove('cwc-ls');
      for (j = 1; j < kids.length; j++) {
        if (kids[j].offsetTop > kids[j - 1].offsetTop + 2) kids[j].classList.add('cwc-ls');
      }
    }
  }

  function prepare() {
    var main = document.getElementById('main-content');
    if (!main) return;
    units(main);
    var els = main.querySelectorAll(HEAD);
    for (var i = 0; i < els.length; i++) build(els[i]);
    measure();
  }

  function run() {
    prepare();
    if (document.fonts && document.fonts.ready) { document.fonts.ready.then(measure); }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run, { once: true });
  } else {
    run();
  }
  window.addEventListener('load', measure, { once: true });
  var t;
  window.addEventListener('resize', function () {
    window.clearTimeout(t);
    t = window.setTimeout(measure, 150);
  });
  document.addEventListener('shopify:section:load', function () { window.setTimeout(prepare, 100); });
})();
